import { DesiredIndex } from '../../enums/take-from-array/desired-index';
import { ResultData } from '../../enums/take-from-array/result-data';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a TakeFromArray task.
 * Extracts a single item from an array field. The item can replace the source array
 * or be written to a named key in processingData.
 */
export class TakeFromArrayConfig extends DestinationTaskConfigBase {
	/** Dot-notation path within processingData to the source array. @default '' */
	collectionField = '';
	/** Which item to extract. FirstItem=0 (index 0), LastItem=1 (last), NthItem=2 (use customIndex). @default DesiredIndex.FirstItem */
	desiredIndex: DesiredIndex = DesiredIndex.FirstItem;
	/** How the extracted item is written. ReplaceSourceArray=0 (item replaces the array), OnlyKeepExtractedValue=1 (processingData becomes { [keyLabel]: item }). @default ResultData.ReplaceSourceArray */
	resultData: ResultData = ResultData.ReplaceSourceArray;
	/** 1-based index of the item to extract. Only used when desiredIndex=NthItem. Service subtracts 1 internally. @default 0 */
	customIndex?: any = 0;
	/** Key name used to wrap the extracted item when resultData=OnlyKeepExtractedValue. @default 'value' */
	keyLabel?: string = 'value';
	/** When true, applies the keyLabel wrapping for OnlyKeepExtractedValue mode. */
	useKeyLabel?: boolean;

	constructor(init?: Partial<TakeFromArrayConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
